import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const GET_FORM_WITH_DRAFT_FIELD_NAME = 'formWithDraft';
export const GET_FORM_WITH_DRAFT = registerQuery({
  fieldName: GET_FORM_WITH_DRAFT_FIELD_NAME,
  args: ['guid'],
  fetcher({
    guid
  }) {
    return http.get(`/forms/v2/forms-drafts/${guid}`);
  }
});
export default function useFetchFormWithDraft(guid) {
  const {
    data,
    error,
    loading
  } = useQuery(GET_FORM_WITH_DRAFT, {
    variables: {
      guid,
      skip: !guid
    }
  });
  return useMemo(() => ({
    data: data && data[GET_FORM_WITH_DRAFT_FIELD_NAME],
    error,
    loading
  }), [data, error, loading]);
}